/**
 * 날짜 선택 필드(.datefield).
 *
 * input[type=date] 는 비어 있어도 브라우저가 'yyyy. mm. dd.' 같은 자기 문구를 보여 준다.
 * 값이 없을 때는 그 문구를 감추고 안내 글자(.datefield__placeholder)를 대신 보여 주기 위해
 * 감싸는 요소에 data-empty 를 표시해 둔다. 스타일은 common.css 가 처리한다.
 */

const InitDateField = () => {
  const fields = document.querySelectorAll('.datefield');

  fields.forEach((field) => {
    const input = field.querySelector('.datefield__input');

    if (!input) {
      return;
    }

    const sync = () => {
      field.dataset.empty = '' === input.value ? 'true' : 'false';
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  });
};

export default InitDateField;
